import { compactReceiptReference, nonTobaccoReceipt } from './receipt-groups.mjs';
import { escposGeometry } from './receipt-geometry';

// Picking slip: no financial values, logo, footer or cash-drawer pulse.
export function buildCompactEscpos(tx, settings) {
  tx = nonTobaccoReceipt(tx);
  const geometry = escposGeometry(settings), width = geometry.columns;
  const clean = value => String(value ?? '').replace(/[\x00-\x1f\x7f]/g, ' ');
  const lines = [];
  const add = value => {
    const text = clean(value);
    for (let i = 0; i < text.length; i += width) lines.push(text.slice(i, i + width));
  };
  const pair = (left, right) => lines.push(left + ' '.repeat(Math.max(1, width - left.length - right.length)) + right);
  if (tx.customer_name) add('Pelanggan: ' + tx.customer_name);
  add((tx.queue_number || tx.invoice_no === 'DRAFT' ? 'Antrean: ' : 'No: ') + compactReceiptReference(tx));
  lines.push('-'.repeat(width));
  pair('Produk', 'QTY');
  for (const item of tx.items) {
    const right = clean(`${item.qty} ${item.unit || item.price_level || 'PCS'}`);
    const name = clean(item.name);
    if (name.length + right.length + 1 <= width) lines.push(name + ' '.repeat(width - name.length - right.length) + right);
    else { add(name); add(right.padStart(width)); }
  }
  lines.push('-'.repeat(width));
  pair('Total Item', String(tx.items.length));
  const text = lines.join('\n') + '\n';
  return new Uint8Array([27,64, ...geometry.commands, ...Array.from(text, char => char.charCodeAt(0) < 256 ? char.charCodeAt(0) : 63), 10,10,29,86,0]);
}
